import { useCallback, useEffect, useState } from "react";
import { OperatingLayout } from "../../../layouts/operating/OperatingLayout";
import { getMemberData } from "../../../utils/helpers/getMemberData";
import { apiRequest, useAccount } from "@vojomo-core/shared";
import type { CollapseProps, DatePickerProps } from "antd";
import { Collapse, DatePicker, Button, ConfigProvider } from "antd";

export const WeeklyAgenda = () => {
  const { companyName } = useAccount();
  const [fiscalYear, setFiscalYear] = useState<string | null>(null);
  const [memberAgendaLink, setMemberAgendaLink] = useState("");
  const [memberAgendaPlatformLink, setMemberAgendaPlatformLink] = useState("");
  const [pickerDateString, setPickerDateString] = useState<string | null>(null);
  const [apiDateString, setApiDateString] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getMemberData(companyName).then((memberInfo) => {
      if (memberInfo !== null) {
        const memberLink: string = memberInfo.member_agenda_link;
        setFiscalYear(memberInfo.member_fiscal_ye);

        const platLink: string = memberInfo.member_agenda_platform_link.replace(
          "https://docs.google.com/spreadsheets/d/",
          ""
        );

        const platAgendaKey = platLink.split("/")[0];
        const platAgendaGid = platLink
          .split("/")[1]
          .replace("edit?gid=", "")
          .split("#")[0];

        const memberPlatformLink = `${platAgendaKey}&gid=${platAgendaGid}`;

        setMemberAgendaLink(memberLink);
        setMemberAgendaPlatformLink(memberPlatformLink);
      }
    });
  }, [companyName]);

  const callNewFormAPI = useCallback(async () => {
    setIsLoading(true);
    const url = `/weekly_agenda/create_new_form_week?member=${companyName}&week_date=${apiDateString}&fiscal_year=${fiscalYear}`;
    await apiRequest({ subRoute: "operating", path: url, method: "POST" }).then(
      (res) => {
        console.log(res);
      }
    );
    setIsLoading(false);
  }, [apiDateString, fiscalYear, companyName]);

  useEffect(() => {
    if (apiDateString) {
      callNewFormAPI();
    }
  }, [apiDateString, callNewFormAPI]);

  const onChange: DatePickerProps["onChange"] = (_, dateString) => {
    if (typeof dateString == "string") {
      setPickerDateString(dateString);
    }
  };

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Create new week",
      children: (
        <div className="flex flex-row items-center content-center self-center align-center">
          <DatePicker format="MM/DD/YYYY" onChange={onChange} />
          <Button
            // color="#A5ACC1"
            loading={isLoading}
            type="primary"
            onClick={() => setApiDateString(pickerDateString)}
            disabled={isLoading}
            className={
              "ml-4 content-center w-[125px] flex items-center self-center align-center justify-center text-center"
            }
          >
            Submit
          </Button>
        </div>
      )
    }
  ];

  const iframeEl = memberAgendaLink ? (
    <div>
      <Collapse ghost items={items} defaultActiveKey={["0"]} />
      <br />
      Link to{" "}
      <a
        target="_blank"
        style={{ textDecoration: "none" }}
        href={`/motion/file_explorer/${memberAgendaPlatformLink}`}
      >
        <b>Operating Platform Objective Status Tab</b>
      </a>
      <br />
      <br />
      <iframe
        style={{
          borderRadius: "10px",
          borderColor: "grey",
          borderWidth: "1px",
          borderStyle: "solid",
          width: "100%",
          height: "62.5vh"
        }}
        src={memberAgendaLink}
      />
    </div>
  ) : (
    <></>
  );
  return (
    <OperatingLayout pageHeader="Weekly Agenda">
      <ConfigProvider theme={{ token: { colorPrimary: "rgb(44, 21, 97)" } }}>
        {iframeEl}
      </ConfigProvider>
    </OperatingLayout>
  );
};
